import { NavLink } from "react-router-dom";
import clsx from "clsx";
import { useGyms } from "../api/hooks";

export function GymTabs({
  basePath,
  className,
}: {
  basePath: "/plannings" | "/reservation";
  className?: string;
}) {
  const { data: gyms } = useGyms();
  if (!gyms?.length) return null;

  return (
    <div className={clsx("flex flex-wrap gap-2", className)}>
      {gyms.map((g) => (
        <NavLink
          key={g.id}
          to={`${basePath}/${g.slug}`}
          className={({ isActive }) =>
            clsx(
              "rounded px-4 py-2 text-sm font-semibold uppercase tracking-wide transition",
              isActive
                ? "bg-brand-500 text-white"
                : "border border-ink-300 text-ink-700 hover:border-brand-500 hover:text-brand-500",
            )
          }
        >
          {g.name}
        </NavLink>
      ))}
    </div>
  );
}
